import appUserService from '../services/appUserService'

export const VIETTEL_MONEY_ERROR = {
  AUTH_SESSION_NOT_FOUND: 'AUTH_SESSION_NOT_FOUND',
  INVALID_AUTH_SESSION: 'INVALID_AUTH_SESSION',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  INVALID_CODE_CHALLENGE: 'INVALID_CODE_CHALLENGE'
}

export const VIETTEL_MONEY_ERROR_MESSAGE = {
  [VIETTEL_MONEY_ERROR.AUTH_SESSION_NOT_FOUND]: 'Phiên đăng nhập không hợp lệ. Vui lòng thử lại.',
  [VIETTEL_MONEY_ERROR.INVALID_AUTH_SESSION]: 'Phiên đăng nhập không hợp lệ. Vui lòng thử lại.',
  [VIETTEL_MONEY_ERROR.USER_NOT_FOUND]: 'Phiên đăng nhập không hợp lệ. Vui lòng thử lại.',
  [VIETTEL_MONEY_ERROR.INVALID_CODE_CHALLENGE]: 'Phiên đăng nhập không hợp lệ. Vui lòng thử lại.'
}

export const VIETTEL_MONEY_DEFAULT_ERROR_MESSAGE = 'Không nhận được thông tin số điện thoại. Vui lòng thử lại.'

export const VIETTEL_MONEY_DEFAULT_ERROR_CODE = 'VIETTEL_MONEY_UNKNOWN_ERROR'

export const SDK_RESULT_STATUS = {
  NO_ATTEMPT: 'no_attempt',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

export const SDK_SOURCE = {
  VIETTEL_MONEY: 'VIETTEL_MONEY',
  URL_PARAMS: 'URL_PARAMS'
}

export const getViettelMoneyUserInfo = async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const code_verifier = urlParams.get('code_verifier') || undefined
  const code = urlParams.get('code') || undefined
  const ptr = urlParams.get('ptr') || undefined
  const payload = {
    code_verifier,
    code,
    ptr
  }

  if (!Object.values(payload).some(Boolean)) {
    return { status: SDK_RESULT_STATUS.NO_ATTEMPT, source: SDK_SOURCE.VIETTEL_MONEY }
  }

  let result

  try {
    result = await appUserService.viettelMoneyAPIAuthorizeWebview(payload)
  } catch (error) {
    return {
      status: SDK_RESULT_STATUS.FAILURE,
      source: SDK_SOURCE.VIETTEL_MONEY,
      errorCode: VIETTEL_MONEY_DEFAULT_ERROR_CODE
    }
  }

  if (result?.statusCode === 200 && result?.data?.phoneNumber) {
    return {
      status: SDK_RESULT_STATUS.SUCCESS,
      source: SDK_SOURCE.VIETTEL_MONEY,
      data: {
        phoneNumber: result.data.phoneNumber,
        fullName: result.data.firstName || '',
        username: result.data.username || ''
      }
    }
  }

  const errorCode = result?.error || VIETTEL_MONEY_DEFAULT_ERROR_CODE

  return {
    status: SDK_RESULT_STATUS.FAILURE,
    source: SDK_SOURCE.VIETTEL_MONEY,
    errorCode
  }
}

export const exitViettelMoneyApp = async () => {}
